import PaymentMethod, { PaymentMethodType } from "./PaymentMethod";

/**
 * 📄 Model representing the Sepa(iDEAL) payment method the user uses to pay the subscription
 */
export default class SepaPaymentMethod implements PaymentMethod {
  public country: string;
  public bankCode: string;
  public last4: string;
  public method: PaymentMethodType;

  constructor(rawPaymentMethod: any) {
    this.country = rawPaymentMethod.country;
    this.bankCode = rawPaymentMethod.bankCode;
    this.last4 = rawPaymentMethod.last4;
    this.method = rawPaymentMethod.method;
  }

  public get displayText(): string {
    return this.bankCode + " account ending on " + this.last4;
  }

  public get image(): string {
    switch (this.bankCode) {
      case "ABNAMRO":
        return "https://js.stripe.com/v3/fingerprinted/img/abnamro-4445e65420800f96f68cfc67a273f66b.svg";
      case "ASN":
        return "https://js.stripe.com/v3/fingerprinted/img/asn-3d9b1bbff2f8f12105510992dbb37ae8.svg";
      case "BUNQ":
        return "https://js.stripe.com/v3/fingerprinted/img/bunq-4b42e7fb68fac0c5abb7ba3492115d81.svg";
      case "HANDELS":
        return "https://js.stripe.com/v3/fingerprinted/img/handelsbanken-4b691bb773ce27a817f6cfc7088a2cbe.svg";
      case "ING":
        return "https://js.stripe.com/v3/fingerprinted/img/ing-f4beb9f58834a82babe38427cec0ba95.svg";
      case "KNAB":
        return "https://js.stripe.com/v3/fingerprinted/img/knab-dbdf61d58d3004c23573158cb91e9569.svg";
      case "MONEYYOU":
        return "https://js.stripe.com/v3/fingerprinted/img/moneyou-d01cd44d799ef10b39d4d31dddd685f7.svg";
      case "RABO":
        return "https://js.stripe.com/v3/fingerprinted/img/rabobank-dc5187e8413419975fda9a72a08c25a3.svg";
      case "REGIO":
        return "https://js.stripe.com/v3/fingerprinted/img/regiobank-d3d9929a79d4e6a127e09ea8abe201b9.svg";
      case "SNS":
        return "https://js.stripe.com/v3/fingerprinted/img/sns-bfdac0e49115f2f30c9fe978b5221531.svg";
      case "TRIODOS":
        return "https://js.stripe.com/v3/fingerprinted/img/triodos-cf5d13d3dea9d1250d2b51a8eb0b53e8.svg";
      case "VANLANSSCHOT":
        return "https://js.stripe.com/v3/fingerprinted/img/vanlanschot-f3223e68b58e3f99122c92f0328f7e59.svg";
      default:
        return "";
    }
  }
}
